const ListColumns = [
  { id: "name", label: "Name" },
  { id: "title", label: "Title" },
  { id: "sponsored", label: "Sponsored name" },
  { id: "action", label: "Actions", noSort: true },
];

const CREATIVE_NATIVE_TEMPLATE_TYPES = {
  IMAGE_CONTENT: "IMAGE_CONTENT",
};

const SPONSORED_ASSET_SIZE = {
  [CREATIVE_NATIVE_TEMPLATE_TYPES.IMAGE_CONTENT]: ["128x128"],
};
export { ListColumns, SPONSORED_ASSET_SIZE, CREATIVE_NATIVE_TEMPLATE_TYPES };
